import { render, staticRenderFns } from "./nosidebar.vue?vue&type=template&id=da3d7010&scoped=true&lang=html&"
import script from "./nosidebar.vue?vue&type=script&lang=js&"
export * from "./nosidebar.vue?vue&type=script&lang=js&"
import style0 from "./nosidebar.vue?vue&type=style&index=0&id=da3d7010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3d7010",
  null
  
)

export default component.exports